import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {
    error,
    info,
    infoMsg,
    REQUIRED,
    saveMsg,
    success,
    updateMsg
} from "../../../components/i18n/i18n";
import {showToastCustom} from "../../../components/toast/customToast";
import {
    ButtonSubmit, GenericTableButton
} from "../../../components/buttons/buttonsActions";
import * as Yup from "yup";
import {ErrorMessage, useForm} from "react-hook-form";
import {showLoader} from "../../../components/loader/loader";
import Switch from "react-bootstrap-switch";
import {geoPickupService} from "../../../jwt/_services/configuration/geoPickupService";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

export const GeoPickupForm = forwardRef( (props, ref) => {

    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [disableInputs, setDisableInputs] = useState(false);
    const [loading, setLoading] = useState(false);

    const [savedData, setSavedData] = useState(editMode ? props.item : null);

    const [pickup] = useState(props.pickup);
    const [status, setStatus] = useState(editMode ? props.item?.status : false);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    const validationSchema = Yup.object().shape({
        hotelId: Yup.string().required(REQUIRED),
        timeId: Yup.string().required(REQUIRED),
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            hotelId: savedData?.hotelId,
            timeId: savedData?.timeId,
        }
    });

    const onSubmit = (data, _) => {
        setLoading(true);
        const dataRequest = {
            id: data.id,
            hotelId: data.hotelId,
            timeId: data.timeId,
            // Booleans
            status: status,
            // Objects
            pickup: pickup,
        };

        if (!editMode) {
            //Save
            return geoPickupService.saveItem(dataRequest)
                .then(_ => {
                    showToastCustom(success, saveMsg);
                    resetForm();
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        } else {
            //Update
            let id = savedData.id;
            delete savedData.id;
            if (JSON.stringify(savedData) === JSON.stringify(dataRequest)) {
                return showToastCustom(info, infoMsg);
            }

            return geoPickupService.updateItem(id, dataRequest)
                .then(_ => {
                    showToastCustom(success, updateMsg);
                    resetForm();
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };

    const resetForm = () => {
        setStatus(false);
        setLoading(false);
        setSavedData(null);
        setEditMode(false);
        setDisableInputs(false);
        reset();
        props.refreshList();
    }

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    const statusChange = () => { setStatus(!status); }

    useImperativeHandle(ref, () => ({
        setFormEdit (itemP) {
            setStatus(itemP?.status);
            setSavedData(itemP);
            setEditMode(true);
        }
    }));

    return (
        <Card>
            {loading && showLoader()}
            <CardTitle>
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>ID</Label>
                                <Input type="id" name="id"
                                       disabled
                                       value={editMode ? savedData?.id : ''}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>Firebase ID</Label>
                                <Input type="uid" name="uid"
                                       disabled
                                       value={editMode ? savedData?.uid : ''}
                                />
                            </FormGroup>
                        </Col>
                    </Row>


                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>Hotel Id</Label>
                                <br/>
                                <Input type="text" name="hotelId"
                                       placeholder="Hotel Id"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.hotelId ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="hotelId" component="div" className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>Hora Id</Label>
                                <br/>
                                <Input type="text" name="timeId"
                                       placeholder="Id de hora"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.timeId ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="timeId" component="div" className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>Activo</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={ status }
                                        disabled={disableInputs}
                                        innerRef={register}
                                        onChange={statusChange}
                                />
                            </FormGroup>
                        </Col>

                    </Row>
                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
})